import avatar from "../assets/img/avatar.png";
import vitri1 from "../assets/img/vitri.png";
import vitri2 from "../assets/img/vitri2_nobg.png";
import vitri3 from "../assets/img/vitri3.png";
import vitri4 from "../assets/img/vitri5-removebg-preview.png";
import vitri5 from "../assets/img/2928883.png";
import nha1 from "../assets/img/nha.png";
import currentLocationIcon from "../assets/img/current_location-icon.png";
import logo_project from "../assets/img/logo_project.jpg";
import logo_project2 from "../assets/img/logo.png";
import logo_batdongsan from "../assets/img/logo_batdongsan4.png";
import newIcon from "../assets/img/new-icon.png";
import oldIcon from "../assets/img/old-icon.png";
import bot from "../assets/img/bot_AI.gif";
import bot_ai from "../assets/img/bot_ai.jpg";

export const appInfo = {
  logo_project,
  logo_project2,
  logo_batdongsan,
  logo: "/static/media/Logo.dac44c6881253282d209.png",
  title: "ADVANCED REAL ESTATE",
  nameAI: "ADVANCED REAL ESTATE AI",
  description: "",
  email: "nhom3@dtu.edu.vn",
  companyName: "Công Ty CP Đất Xanh Miền Trung",
  address: "15 Quang Trung, Hải Châu 1, Hải Châu, Đà Nẵng",
  phoneNumber: "+84915662495",
  avatar: avatar,
  vitri1: vitri1,
  vitri2: vitri2,
  vitri3,
  vitri4,
  vitri5,
  nha1,
  currentLocationIcon,
  newIcon,
  oldIcon,
  bot,
  bot_ai,
  SERVER_URL: "https://batdongsan.hoclaptrinhiz.com",
  LOCAL_URL: "http://localhost:9090",
};
